<template>
  <div class="container">
    <section class="catalog">
      <div class="row">
        <div class="col-sm-3">
          <filter></filter>
          <!-- <subcategories></subcategories> -->
          <!-- <color></color> -->
        </div>
        <div class="col-sm-9">
          <h3 v-if="selectionProducts.length && !loadingSelection" class="text-center">{{ selectionName }}</h3>

          <div class="row catalog-cards" style="margin-bottom: 20px">
            <div class="col-xs-12 col-sm-6 col-md-4" v-for="product in selectionProducts | filter min max null null">
              <cards :product="product"></cards>
            </div>
          </div>
          <!-- <div v-if="!render_results.length" class="category-title">
            <div v-if="searching" class="loading-products text-general empty">Buscando productos<loader class="loader"></loader></div>
            <div v-else>  
              <h2 class="no-top text-uppercase">Lo sentimos</h2>
              <p class="text-general">No encontramos algo relacionado con tu búsqueda</p>
              <ul class="text-gray-sm">
                <li>Prueba cambiando algunas palabras</li>
                <li>Revisa las categorías para encontrar productos similares</li>
              </ul>
            </div>
          </div> -->

          <div class="col-xs-12">
            <p class="text-general text-center loading-products empty" v-if="!selectionProducts.length && loadingSelection">Cargando seleccion <loader class="loader"></loader></p>
            <p class="text-general text-center loading-products empty" v-if="!selectionProducts.length && !loadingSelection">No se encontro la seleccion {{ selection }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .no-top{
    margin-top: 0;
    padding-top: 0;
  }
  .col-sm-4{
    margin-bottom: 30px;
  }
  .col-sm-9{
    padding-left: 20px;
  }
  ul{
    padding: 60px 30px;
  }
</style>

<script>

import Cards from '../components/Home/Card.vue';
import Filter from '../components/Product/Filter.vue';
import Subcategories from '../components/Product/Subcategories.vue';
import Color from '../components/Product/Color.vue';
import Store from '../store/store';
import { search, getSelections } from '../store/actions';
import { router } from '../routes/routes';
import Loader from '../components/Loader.vue';
import Pagination from '../components/Pagination.vue';
import { toast } from '../scripts/toast';

export default {
  // ---- DATA ----

  data () {
    return {
      selectionProducts: [],
      loadingSelection: true
    };
  },

  // ---- VUEX ----

  vuex: {
    getters: {
      min: state => state.min_price,
      max: state => state.max_price,
    },
    actions: {
      getSelections
    }
  },

  computed:  {
    selection () {
      return this.$route.params.selections
    },

    selectionName () {
      return this.selection.split('-').join(' ').toUpperCase()
    }
  },

  components: {
    Cards,
    Filter,
    Subcategories,
    Color,
    Loader,
    Pagination
  },

  ready () {
    if (this.selection) {
      this.getSelections(this.selection).then(res => {
        this.loadingSelection = false
        this.selectionProducts = res.products
      }).catch(err => {
        this.loadingSelection = false
        console.error('Error', err)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Selections.vue?d383da54